import React from 'react';

// Components
import { Divider } from '@src/components/Divider';
import Cards from '../Cards';

// Styles && Icons
import './styles.scss';

export default function PaymentMethods() {
  return (
    <div className="payment">
      <Divider
        className="payment__methods-divider"
        text="Add, review or change your payment methods."
        title="Payment method"
      />

      <Cards />
    </div>
  );
}
